"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryBluePage = queryBluePage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
/**
 * 蓝票列表
 * @param query
 * @returns {*}
 */
function queryBluePage(query) {
  return (0, _requestPIM.default)({
    url: '/xyInvoiceBlue/page',
    method: 'get',
    params: query
  });
}